module.exports = __webpack_public_path__ + "static/img/3s-platform-img2.2810df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-platform-img2.png
// module id = jz4q
// module chunks = 0